var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 21.5H21C20.45 21.5 20 21.05 20 20.5C20 19.95 20.45 19.5 21 19.5H25C25.55 19.5 26 19.95 26 20.5C26 21.05 25.55 21.5 25 21.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 24.5H21C20.45 24.5 20 24.05 20 23.5C20 22.95 20.45 22.5 21 22.5H25C25.55 22.5 26 22.95 26 23.5C26 24.05 25.55 24.5 25 24.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 16L29 14.5L27.5 16L26 14.5L24.5 16L23 14.5L21.5 16L20 14.5L18.5 16L17 14.5V28.5H15C14.45 28.5 14 28.95 14 29.5V31.5C14 33.16 15.34 34.5 17 34.5H29C30.66 34.5 32 33.16 32 31.5V14.5L30.5 16ZM26 32.5H17C16.45 32.5 16 32.05 16 31.5V30.5H19H23H26V32.5ZM30 31.5C30 32.05 29.55 32.5 29 32.5C28.45 32.5 28 32.05 28 31.5V29.5C28 28.95 27.55 28.5 27 28.5H25H23H19V17.5H30V31.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21.5C28.5523 21.5 29 21.0523 29 20.5C29 19.9477 28.5523 19.5 28 19.5C27.4477 19.5 27 19.9477 27 20.5C27 21.0523 27.4477 21.5 28 21.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 24.5C28.5523 24.5 29 24.0523 29 23.5C29 22.9477 28.5523 22.5 28 22.5C27.4477 22.5 27 22.9477 27 23.5C27 24.0523 27.4477 24.5 28 24.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.196bdb3aca280150d90f91dea2242049.svg";
export { ForwardRef as ReactComponent };